/**
Throw in all generic functions here
 */
const intToChar = function(int: number): string {
	return String.fromCharCode(97 + int).toUpperCase();
};

const rand = function(min: number, max: number): number {
	return Math.floor(Math.random() * (max - min) + min);
};

const guid = function(): string {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	return (
		s4() +
		s4() +
		"-" +
		s4() +
		"-" +
		s4() +
		"-" +
		s4() +
		"-" +
		s4() +
		s4() +
		s4()
	);
};

export { intToChar, rand, guid };
